/**
 * Push an event to the GTM dataLayer. Safe to call before GTM loads —
 * events queue up and are processed once the container initialises.
 */
export function pushDataLayerEvent(event: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push(event)
}
